// This file is auto-generated at build time
export const APP_VERSION = '0.1.0.1793764698512';
